import React from 'react'
import LimitSelector from '../LimitSelector/LimitSelector'
import DateRangeSelector from '../DateSelector/DateSelector'
import './filterComponent.css'
import GiftFilters from '../GiftsFilters/GiftFilters'
import SearchFilter from '../SearchFilter/SearchFilter'
import PostsFilters from '../PostsFilters/PostsFilters'
import UsersFilterSearch from '../UsersFilter/UsersFilter'
import TimeframeFilter from '../TimeframeFilter/TimeframeFilter'
import OrdersFilter from '../OrdersFilter/OrdersFilter'
import DepositWithdrawFilter from '../DepositWithdrawFilter/DepositWithdrawFilter'
import DropdownSelector from '../DropdownSelector/DropdownSelector'
import TooltipSlider from '../RangeSlider/TooltipSlider'
import MarginTickerFilter from '../MarginTickerFilter/MarginTickerFilter'
import CheckboxSelector from '../CheckboxSelector/CheckboxSelector'

const FilterComponent = ({
    limit,
    posts,
    date,
    simpleDate,
    usersFilter,
    gift,
    withSearch,
    useSearchFilter,
    typeFilter, setTypeFilter,
    search, setSearch, searchPlaceHolder,
    fetchLimit, limitOptions,
    setFetchLimit,
    selectedDate,
    maxDate,
    setSelectedDate,
    giftOptions, giftTypes, setGiftTypes,
    useAlpaca, useSumsub,
    useLiquidNetWorth,
    setLiquidNetWorth,
    setAlpacaFilter,
    setSumsubFilter,
    timeframeFilterConfig,
    timeframeFilter,
    setTimeframeFilter,
    ordersFilter,
    hideCancel, hideOnHold,
    isPurchase, setIsPurchase,
    isSale, setIsSale,
    isOnHold, setIsOnHold,
    isCanceled, setIsCanceled,
    depositWithdrawFilter,
    isDeposit, setIsDeposit,
    isWithdraw, setIsWithdraw,
    depositWithdrawStatus, setDepositWithdrawStatus,
    useDropdown, dropdowns,
    useCheckboxes, checkboxes,
    useRangeSliderFilter,
    sliderMin, sliderMax, handleRange, sliderValues, setSliderValues,
    useMarginTickerFilter, marketCap, setMarketCap

}) => {

    return (
        <div className='filter_component_box'>
            {
                limit && <LimitSelector
                    noReset={true}
                    fetchLimit={fetchLimit}
                    setFetchLimit={setFetchLimit}
                    options={limitOptions}
                />
            }
            {
                date && <DateRangeSelector
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    simpleDate={simpleDate || false}
                    maxDate={maxDate}
                />
            }
            {
                useDropdown && Array.isArray(dropdowns) &&
                dropdowns.map(({ label, value, setter, options }) =>
                    <DropdownSelector
                        key={label}
                        label={label}
                        options={options}
                        setDropdownSelected={setter}
                        dropdownSelected={value}
                    />
                )
            }
            {
                useCheckboxes && Array.isArray(checkboxes) &&
                checkboxes.map(({ label, value, setter }) =>
                    <CheckboxSelector
                        key={label}
                        label={label}
                        setCheckboxSelected={setter}
                        checkboxSelected={value}
                    />
                )
            }
            {
                posts && <PostsFilters typeFilter={typeFilter} setTypeFilter={setTypeFilter} />
            }
            {
                usersFilter && <UsersFilterSearch
                    useAlpaca={useAlpaca}
                    useSumsub={useSumsub}
                    useSearchFilter={useSearchFilter}
                    useLiquidNetWorth={useLiquidNetWorth}
                    setLiquidNetWorth={setLiquidNetWorth}
                    typeFilter={typeFilter}
                    setTypeFilter={setTypeFilter}
                    setAlpacaFilter={setAlpacaFilter}
                    setSumsubFilter={setSumsubFilter} />
            }
            {
                gift && <GiftFilters
                    options={giftOptions}
                    selected={giftTypes} setSelected={setGiftTypes}
                />
            }
            {
                timeframeFilter && <TimeframeFilter
                    timeframeFilter={timeframeFilter}
                    setTimeframeFilter={setTimeframeFilter}
                    timeframeFilterConfig={timeframeFilterConfig}
                />
            }
            {
                ordersFilter && <OrdersFilter
                    isPurchase={isPurchase}
                    isSale={isSale}
                    isOnHold={isOnHold}
                    isCanceled={isCanceled}
                    setIsPurchase={setIsPurchase}
                    setIsSale={setIsSale}
                    setIsOnHold={setIsOnHold}
                    setIsCanceled={setIsCanceled}
                    hideCancel={hideCancel}
                    hideOnHold={hideOnHold}
                />
            }
            {
                withSearch && <SearchFilter
                    search={search}
                    setSearch={setSearch}
                    searchPlaceHolder={searchPlaceHolder} />
            }
            {
                depositWithdrawFilter && <DepositWithdrawFilter
                    isDeposit={isDeposit}
                    setIsDeposit={setIsDeposit}
                    isWithdraw={isWithdraw}
                    setIsWithdraw={setIsWithdraw}
                    status={depositWithdrawStatus}
                    setStatus={setDepositWithdrawStatus}
                />
            }
            {
                useRangeSliderFilter &&
                <TooltipSlider
                    range
                    min={sliderMin}
                    max={sliderMax}
                    defaultValue={sliderValues}
                    onChangeComplete={setSliderValues}
                />

            }
            {
                useMarginTickerFilter &&
                <MarginTickerFilter
                    marketCap={marketCap}
                    setMarketCap={setMarketCap}
                />
            }
        </div>
    )
}

export default FilterComponent